import { render, staticRenderFns } from "./AppBreadcrumbs.vue?vue&type=template&id=51d2468a&scoped=true&"
import script from "./AppBreadcrumbs.vue?vue&type=script&lang=ts&"
export * from "./AppBreadcrumbs.vue?vue&type=script&lang=ts&"
import style0 from "./AppBreadcrumbs.vue?vue&type=style&index=0&id=51d2468a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51d2468a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBreadcrumbs } from 'vuetify/lib/components/VBreadcrumbs';
installComponents(component, {VBreadcrumbs})
